import PropTypes from "prop-types"
import classnames from "classnames"
import { formatLongDate } from "helpers/formatters/dates"
import { getSortOrderUpdates } from "helpers/compositeSecurities"
import DailyDetails from "./components/daily-details"
import Contributors from "modules/analyze-composite-exposure-contributors"
import { METRIC_TYPES_SHAPE } from "helpers/metrics/shapes"
import "./style.scss"

function AnalyzeCompositeExposureDetails({
  account,
  modelId,
  positionSetId,
  positionSetType,
  positionSetName,
  segment,
  classifications,
  sortOrder,
  selectedDate,
  selectedContributorCategory,
  selectedContributorValue,
  selectedViewsFactors,
  details,
  viewType,
  expand,
  aggregation,
  mustAggregateFactors,
  factorsClassification,
  factorCategoryId,
  factorCategoryName,
  drift,
  openFactorProfile,
  openSecurityProfile,
  currentGrouping,
  selectedOption,
  groupOrder,
  contentSetId,
  selectedViews,
  showNotHeld,
  base,
  baseSignature,
  setGrouping,
  setSortOrder,
  setGroupSortOrder,
  showContributorCategory,
  hideContributorCategory,
  showGroup,
  hideGroup,
  metricType,
  formatter,
}) {
  const handleSort = ({ by, current }) => {
    setSortOrder({
      ...current,
      ...getSortOrderUpdates({ by, current }),
    })
  }

  return <div className={classnames("modules_analyze-composite-exposure-details")}>
    <h4 className="header"><span>As of {formatLongDate(selectedDate)}</span></h4>
    {!selectedContributorCategory ? <DailyDetails {...{
      drift,
      viewType,
      openFactorProfile,
      factorCategoryName,
      data: details,
      factorTable: factorCategoryId !== "total" && factorCategoryId !== "factors",
      show: showContributorCategory,
      groupSort: (order) => setGroupSortOrder({ ...groupOrder, order }),
      groupOrder,
      formatter,
    }}
    /> : <Contributors {...{
      account,
      modelId,
      positionSetId,
      positionSetType,
      positionSetName,
      viewType,
      segment,
      classifications,
      expand,
      aggregation,
      mustAggregateFactors,
      factorsClassification,
      openSecurityProfile,
      openFactorProfile,
      selectedViewsFactors,
      selectedContributorCategory,
      selectedContributorValue,
      showContributorCategory,
      hideContributorCategory,
      currentGrouping,
      showGroup,
      hideGroup,
      sortOrder,
      sort: handleSort,
      selectedDate,
      selectedOption,
      contentSetId,
      details,
      groupOrder,
      selectedViews,
      showNotHeld,
      base,
      baseSignature,
      setGrouping,
      metricType,
      formatter,
    }}
    />}
  </div>
}

AnalyzeCompositeExposureDetails.propTypes = {
  account: PropTypes.string.isRequired,
  modelId: PropTypes.string.isRequired,
  positionSetId: PropTypes.string.isRequired,
  positionSetType: PropTypes.string.isRequired,
  positionSetName: PropTypes.string.isRequired,
  segment: PropTypes.object,
  classifications: PropTypes.array,
  aggregation: PropTypes.string,
  mustAggregateFactors: PropTypes.bool,
  factorsClassification: PropTypes.object,
  sortOrder: PropTypes.object.isRequired,
  setSortOrder: PropTypes.func.isRequired,
  selectedDate: PropTypes.string,
  showContributorCategory: PropTypes.func.isRequired,
  hideContributorCategory: PropTypes.func.isRequired,
  selectedContributorCategory: PropTypes.object,
  selectedContributorValue: PropTypes.number,
  exposure: PropTypes.array,
  details: PropTypes.array,
  viewType: PropTypes.string,
  selectedViewsFactors: PropTypes.array,
  expand: PropTypes.bool,
  factorCategoryId: PropTypes.string,
  factorCategoryName: PropTypes.string.isRequired,
  allCategoryItems: PropTypes.array.isRequired,
  drift: PropTypes.object,
  openFactorProfile: PropTypes.func,
  openSecurityProfile: PropTypes.func,
  currentGrouping: PropTypes.object,
  selectedOption: PropTypes.object.isRequired,
  contentSetId: PropTypes.string,
  filtersVisible: PropTypes.bool.isRequired,
  groupOrder: PropTypes.object.isRequired,
  setGroupSortOrder: PropTypes.func.isRequired,
  setGrouping: PropTypes.func.isRequired,
  showGroup: PropTypes.func.isRequired,
  hideGroup: PropTypes.func.isRequired,
  selectedViews: PropTypes.array,
  showNotHeld: PropTypes.bool.isRequired,
  base: PropTypes.object,
  baseSignature: PropTypes.string,
  formatter: PropTypes.func,
  metricType: METRIC_TYPES_SHAPE.isRequired,
}

export default AnalyzeCompositeExposureDetails
